import { render, staticRenderFns } from "./OwnReports.vue?vue&type=template&id=d2cfd9b8&scoped=true"
import script from "./OwnReports.vue?vue&type=script&lang=js"
export * from "./OwnReports.vue?vue&type=script&lang=js"
import style0 from "./OwnReports.vue?vue&type=style&index=0&id=d2cfd9b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cfd9b8",
  null
  
)

export default component.exports